import type { IconProps } from './../../models/icon';

export function PeaceIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M13.4534 9.58821C17.0292 10.2812 20.2599 11.5025 19.7722 14.4779C19.4892 16.2038 19.3333 19.086 17.0292 21.3352V23.0549L7.07319 23.0551V20.8531C3.9619 19.6125 3.47592 16.9438 3.61798 14.7433C3.7073 13.3601 4.96339 12.3966 6.34954 12.3966L6.38666 12.3932L4.10313 3.82849C3.82274 2.77683 4.45191 1.72408 5.51109 1.4727C6.57199 1.22091 7.66459 1.86784 7.95406 2.91918L9.59589 8.88229L10.3412 2.60967C10.4468 1.70551 11.2127 1.02373 12.1231 1.02374C13.1625 1.02376 13.9844 1.90437 13.9127 2.94135L13.4534 9.58821Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M17.0294 23.0549C17.0294 22.5064 17.0294 22.1224 17.0294 21.3352C19.3335 19.086 19.4895 16.2038 19.7723 14.4779C20.2602 11.5025 17.0294 10.2812 13.4535 9.58821L13.9129 2.94135C13.9845 1.90437 13.1627 1.02376 12.1233 1.02374C11.2129 1.02373 10.4469 1.70551 10.3414 2.60967L9.59608 8.88229L7.95426 2.91918C7.66478 1.86784 6.57218 1.22091 5.51128 1.4727C4.45211 1.72408 3.82293 2.77683 4.10332 3.82849L6.38685 12.3932"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M7.07319 23.0548V20.8529C3.9619 19.6121 3.47592 16.9435 3.61798 14.7431C3.7073 13.3598 4.96339 12.3964 6.34954 12.3964H11.3737C12.2806 12.3964 13.0157 13.1315 13.0157 14.0383C13.0157 14.7976 12.495 15.4579 11.7566 15.635L8.91254 16.3169C9.80863 16.1701 11.8555 17.0743 11.9309 19.0473"
      />
    </svg>
  );
}
